function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_549",
  "data-name": "Path 549",
  d: "M818.888,580.354a11.522,11.522,0,0,1-4.134-9.933,9.315,9.315,0,0,1,6.925-7.908,7.84,7.84,0,0,1,8.928,4.962c.611-6.881,1.314-14.05,4.973-19.91a21.085,21.085,0,0,1,15.268-9.782,18.919,18.919,0,0,1,16.643,6.794,17.17,17.17,0,0,1,2.111,17.677c-2,4.151-5.687,7.24-9.549,9.753a61.63,61.63,0,0,1-42.151,9.221Z",
  transform: "translate(-630.462 -448.546)",
  fill: "#f2f2f2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_550",
  "data-name": "Path 550",
  d: "M909.9,545.6a101.693,101.693,0,0,0-29.88,40.4c-.285.7.849,1,1.131.312a100.561,100.561,0,0,1,29.578-39.886C911.312,545.952,910.478,545.126,909.9,545.6Z",
  transform: "translate(-679.018 -454.333)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_551",
  "data-name": "Path 551",
  d: "M236.784,531.545a15.826,15.826,0,0,0,5.678-13.643c-.625-5.1-4.493-9.78-9.512-10.862s-10.739,1.913-12.263,6.815c-.839-9.451-1.805-19.3-6.83-27.346a28.961,28.961,0,0,0-20.971-13.435,25.985,25.985,0,0,0-22.859,9.331,23.583,23.583,0,0,0-2.9,24.28c2.748,5.7,7.811,9.944,13.116,13.4a84.648,84.648,0,0,0,57.894,12.665",
  transform: "translate(-165 -400.393)",
  fill: "#f2f2f2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_552",
  "data-name": "Path 552",
  d: "M213.467,483.809a138.493,138.493,0,0,1,19.3,19.166A138.9,138.9,0,0,1,254.507,539.3c.391.959-1.166,1.377-1.553.428a138.122,138.122,0,0,0-40.626-54.783C211.524,484.293,212.67,483.16,213.467,483.809Z",
  transform: "translate(-199.994 -408.342)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_553",
  "data-name": "Path 553",
  d: "M518.053,322.955H424.5V226.967a37.078,37.078,0,0,1,37.036-37.037h19.48a37.078,37.078,0,0,1,37.036,37.037Z",
  transform: "translate(-348.892 -189.931)",
  fill: "#f2f2f2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_554",
  "data-name": "Path 554",
  d: "M498.573,322.958H424.5V226.97a36.75,36.75,0,0,1,7.073-21.772c.17-.232.34-.461.515-.687a37.027,37.027,0,0,1,7.883-7.651c.169-.123.339-.244.511-.365a36.95,36.95,0,0,1,8.067-4.219c.169-.064.342-.129.514-.19a36.914,36.914,0,0,1,7.973-1.88c.169-.023.342-.041.515-.059a37.495,37.495,0,0,1,7.973,0c.173.018.346.036.516.059a36.907,36.907,0,0,1,7.971,1.88c.173.062.345.126.515.19a36.858,36.858,0,0,1,7.973,4.156c.172.118.344.239.514.36a37.419,37.419,0,0,1,4.712,3.989,36.986,36.986,0,0,1,3.261,3.729c.174.226.344.455.514.686a36.751,36.751,0,0,1,7.073,21.772Z",
  transform: "translate(-350.082 -189.934)",
  fill: "#ccc"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_234",
  "data-name": "Ellipse 234",
  cx: 4.101,
  cy: 4.101,
  r: 4.101,
  transform: "translate(141.212 81.89)",
  fill: "#f0b543"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_555",
  "data-name": "Path 555",
  d: "M581.143,472.615H578l-1.5-12.12h4.638Z",
  transform: "translate(-416.764 -342.467)",
  fill: "#ffb8b8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_556",
  "data-name": "Path 556",
  d: "M562.51,504.28h6.06V508.1h-9.876A3.816,3.816,0,0,1,562.51,504.28Z",
  transform: "translate(-403.603 -375.029)",
  fill: "#2f2e41"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_557",
  "data-name": "Path 557",
  d: "M642.143,472.615H639l-1.5-12.12h4.638Z",
  transform: "translate(-460.862 -342.467)",
  fill: "#ffb8b8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_558",
  "data-name": "Path 558",
  d: "M623.51,504.28h6.06V508.1h-9.876A3.816,3.816,0,0,1,623.51,504.28Z",
  transform: "translate(-447.67 -375.029)",
  fill: "#2f2e41"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_559",
  "data-name": "Path 559",
  d: "M696.719,431.393a2.753,2.753,0,0,1,1.156-4.061l10.682-29.441,5.256,2.868-12.2,28.135a2.768,2.768,0,0,1-4.9,2.5Z",
  transform: "translate(-548.349 -344.589)",
  fill: "#ffb8b8"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_560",
  "data-name": "Path 560",
  d: "M802.583,447.759a2.753,2.753,0,0,1-.741-4.156l-3.309-31.144,5.982.273,1.375,30.634a2.768,2.768,0,0,1-3.306,4.393Z",
  transform: "translate(-622.771 -355.423)",
  fill: "#ffb8b8"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_235",
  "data-name": "Ellipse 235",
  cx: 6.295,
  cy: 6.295,
  r: 6.295,
  transform: "translate(163.262 35.258)",
  fill: "#ffb8b8"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_561",
  "data-name": "Path 561",
  d: "M759.112,420.757H740.133l.023-.148c.034-.221,3.382-22.155.913-29.331a3.028,3.028,0,0,1,1.556-3.738h0c3.53-1.662,10.306-3.709,16.024,1.258a7.237,7.237,0,0,1,2.425,6Z",
  transform: "translate(-579.806 -335.504)",
  fill: "#f0b543"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_562",
  "data-name": "Path 562",
  d: "M729.562,407.8l-8.544-1.733,4.005-9.491a3.588,3.588,0,0,1,6.947,1.794Z",
  transform: "translate(-566.603 -341.611)",
  fill: "#f0b543"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_563",
  "data-name": "Path 563",
  d: "M795.356,412.949l-.514-11.775a3.62,3.62,0,1,1,7.07-1.224l1.931,11Z",
  transform: "translate(-620 -343.538)",
  fill: "#f0b543"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path_564",
  "data-name": "Path 564",
  d: "M755.514,517.049c3.054,11.63,3.387,26.418,2.563,42.547l-4.1-.513-7.433-30.757-4.1,31.27-4.614-.256c-1.378-16.924-2.72-31.453-.513-41.009Z",
  transform: "translate(-576.842 -433.206)",
  fill: "#2f2e41"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_565",
  "data-name": "Path 565",
  d: "M759.324,330.234a2.033,2.033,0,0,1-3.508-1.13,2.063,2.063,0,0,1,0-.4,9.245,9.245,0,0,0,.412-2.244,1.177,1.177,0,0,0-.215-.551c-.936-1.253-3.133.56-4.016-.574-.542-.7.1-1.791-.321-2.568-.549-1.026-2.173-.52-3.192-1.082-1.134-.625-1.066-2.365-.32-3.422a5.384,5.384,0,0,1,4.081-2.078,10.949,10.949,0,0,1,4.612.9,9.216,9.216,0,0,1,4.357,3.021,7.376,7.376,0,0,1,.746,6.28A11.838,11.838,0,0,1,759.324,330.234Z",
  transform: "translate(-585.597 -283.816)",
  fill: "#2f2e41"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path_566",
  "data-name": "Path 566",
  d: "M472.7,707.8H265.831a.306.306,0,1,1,0-.61H472.7a.306.306,0,1,1,0,.61Z",
  transform: "translate(-239.739 -574.614)",
  fill: "#3f3d56"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Path_567",
  "data-name": "Path 567",
  d: "M532.486,375.092h-33.32a1.657,1.657,0,0,1-1.666-1.644V299.075a1.657,1.657,0,0,1,1.666-1.644h33.32a1.657,1.657,0,0,1,1.666,1.644v74.373A1.657,1.657,0,0,1,532.486,375.092Z",
  transform: "translate(-404.182 -269.878)",
  fill: "#fff"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_567",
  "data-name": "Rectangle 567",
  width: 36.652,
  height: 0.513,
  transform: "translate(93.318 51.618)",
  fill: "#ccc"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_568",
  "data-name": "Rectangle 568",
  width: 36.652,
  height: 0.513,
  transform: "translate(93.458 80.865)",
  fill: "#ccc"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_569",
  "data-name": "Rectangle 569",
  width: 0.513,
  height: 77.918,
  transform: "translate(104.454 27.553)",
  fill: "#ccc"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_570",
  "data-name": "Rectangle 570",
  width: 0.513,
  height: 77.918,
  transform: "translate(118.289 27.553)",
  fill: "#ccc"
});

function SvgDownloadMaterials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_96_1",
    "data-name": "Component 96 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 240.688,
    height: 133.305,
    viewBox: "0 0 240.688 133.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadMaterials);
export default __webpack_public_path__ + "static/media/download_materials.e8412e51.svg";
export { ForwardRef as ReactComponent };